import React from 'react';
import { Menu, Navigation } from '@econ/ui-elements';
import useCachedQuery from '../../hooks/useCachedQuery';
import Link from '../AuthorizedMenuLink';
import Text from '../l10n/Text';
import { Quicklink } from '../../../../types';

interface LayoutProps {
    children: React.ReactNode;
}

const Layout = ({ children, ...props }: LayoutProps) => (
    <div {...props} id="layout">
        {children}
    </div>
);

interface NavigationProps {
    children: React.ReactNode;
    showQuicklinks?: boolean;
}

const LayoutNavigation = ({ children, showQuicklinks = true }: NavigationProps) => {
    const quicklinksQuery = useCachedQuery<Quicklink[]>('/user/quicklinks', []);

    return (
        <div id="navigation">
            <Navigation>
                {children}
                {showQuicklinks ? (
                    quicklinksQuery.data.length ? (
                        <Menu title={<Text id="LEFTMENU_FIREBIRD_QUICKLINKS">Quicklinks</Text>} open>
                            {quicklinksQuery.data.map(quicklink =>
                                quicklink.url ? (
                                    <Link key={quicklink.url} href={quicklink.url} ignoreTranslations>
                                        {quicklink.name}
                                    </Link>
                                ) : null
                            )}
                        </Menu>
                    ) : null
                ) : null}
            </Navigation>
        </div>
    );
};

interface ContentProps {
    children: React.ReactNode;
}

const LayoutContent = ({ children }: ContentProps) => (
    <div role="main" id="main">
        {children}
    </div>
);

Layout.Navigation = LayoutNavigation;
Layout.Content = LayoutContent;

export default Layout;
